<template>
  <div class="container">
    <div class="searchArea">
      <div class="search-side">
        <img src="@/assets/img/CA_Tournament_black.png" class="entity_logo floatright align-entity" />
      </div>
      <div class="search-combo">
        <input type="text" class="search-box" v-model.lazy="searchString" v-debounce="1000" :placeholder="$t('tournaments.search')" autofocus>
        <font-awesome-icon icon="search" class="icon-overlap"/>
      </div>
      <div class="search-side">
        <div v-if="isLoading" class="spincontainer">
          <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
        </div>
        <div class="action-button-area">
          <button v-if="loggedIn" class="button-icon square-icon floatup floatright" href="#" title="add tournament"  @click="addTournament()"><font-awesome-icon icon="plus-square" class="align-icon"/> {{ $t('tournament.tournament')}}</button>
        </div> 
      </div>
    </div>
    <tournaments-list :tournaments="tournaments" :listType="'Card'"></tournaments-list>
  </div>
</template>

<script>
import v4 from 'uuid'
import TournamentsList from "@/components/tournaments/TournamentsList";
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const listPath = '/tournament';
const myInit = { 
  response: false, 
};

export default {
  name: 'TournamentsDashboard',
  components: {TournamentsList},
  data: function () {
    return {
      loading: true,
      searchString: "",
      tournaments: []
    }
  },
  computed: {
    isLoading() {
      return this.loading;
    },
    loggedIn() {
      console.log("Checking loggedIn status in TournamentsDashboard: " + this.$CAUser.loggedIn());
      return this.$CAUser.loggedIn();
    }
  },
  methods: {
    addTournament() {
      this.$router.push({name: 'EditTournamentDetails', params: {tournamentId: v4()}, query: {mode: 'create'}})
    },
  },
  beforeMount() {
    let that = this
    console.log("Mounting tournaments");
    RestAPI
      .get(apiName, listPath, myInit)
      .then(response => {
        that.tournaments = response;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    searchString: function () {
      this.loading = true;
      let that = this;
      if (this.searchString == "") {
        RestAPI
          .get(apiName, listPath, myInit)
          .then(response => {
            that.tournaments = response;
          })
          .catch(error => {
            console.log(error.response);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let fullPath = listPath + "?name=" + encodeURIComponent(this.searchString);
        console.log("loading tournaments from: " + fullPath);
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.tournaments = response;
            console.log("tournaments loaded: " + that.tournaments.length);
          })
          .catch(error => {
            console.log(error.response);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.imgbtn {
  float: right;
  border: 1px solid #333333;
  border-radius: 2px;
}

.button {
  min-width: 100px;
  height: 40px;
  border-radius: 2px;
  border: 1px solid #223a5e;
  color: #5681c2;
  background-color: inherit;
  float: right;
} 

.button:hover {
  box-shadow: 1px 1px #5681c2;
  transition: box-shadow .3s linear;
} 

.spincontainer {
  margin-left: 10px;
  padding-top: 12px;
}

@keyframes spinner {
  to { transform: rotate(360deg); }
}
.fa-spinner {
  animation: spinner 3s linear infinite;
}


/* mobile */
@media screen and (max-width: 600px) {
  .container {
    padding: 1vw;
    width: 98vw;
  }

  input {
    width: 95vw;
  }

  header {
    padding: 1vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    padding: 1vw;
    width: 70vw;
  }

  input {
    width: 50vw;
  }

  header {
    padding: 1vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    padding: 1vw;
    width: 50vw;
  }

  input {
    width: 30vw;
  }

  header {
    padding: 1vw;
  }
}


</style>
